import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import useAuth from 'src/hooks/useAuth'
import useSentry from 'src/hooks/useSentry'
import { apiUpdateRateRestrictions } from '../../../api/services/updateraterestrictions/updateraterestrictions'
import { ApiUpdateRateRestrictionsPostData } from '../../../api/services/updateraterestrictions/updateraterestrictions.types'
import { selectUser } from '../../../redux/slices/UserSlice/UserSlice.selectors'
import { useAppDispatch, useAppSelector } from '../../reduxHooks'

const useApiUpdateRateRestrictions = () => {
  const dispatch = useAppDispatch()
  const { serverUrl: serverPath, token: userToken } = useAppSelector(selectUser)
  const { captureError } = useSentry()
  const { logoutUser } = useAuth()

  const { t } = useTranslation()

  const [loading, setLoading] = useState(false)

  const updateRates = async (
    data: Omit<ApiUpdateRateRestrictionsPostData, 'userToken'>
  ) => {
    setLoading(true)
    try {
      const response = await apiUpdateRateRestrictions({
        serverPath,
        data: {
          userToken,
          ...data
        }
      })
      const resData = response.data
      if (!resData.ok) {
        if (resData.statusType === 'UNAUTHORIZED') {
          logoutUser()
        } else {
          throw new Error(resData.error)
        }
      }
      toast.success(t('alerts.data_saved'))
    } catch (error) {
      toast.error(t('errors.an_error_has_ocurred'))
      console.log(error)
      captureError(error, {
        description: 'error from updateRates useApiUpdateRateRestriction.tsx'
      })
      throw error
    } finally {
      setLoading(false)
    }
  }

  return {
    updateRates,
    loading
  }
}

export default useApiUpdateRateRestrictions
